
/* eslint-disable */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */

import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { tabValues, SearchDataModel, SelectedSearchResult, SearchResultModal } from '../../contracts/modal';
import { GlobalSearchFiltersService } from './../../services/global-search-filters.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'nalco-search-modal',
    templateUrl: './search-modal.component.html',
    styleUrls: ['./search-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SearchResultModalComponent implements OnInit {

  @Input() public searchData: SearchDataModel;

  @Output() public selectedSearchedResult: EventEmitter<SearchResultModal> = new EventEmitter();
  @Output() public multipleSelectedSearchedResult?: EventEmitter<SearchResultModal[]> = new EventEmitter();
  @Output() public isClearSelectionEmitted: EventEmitter<Boolean> = new EventEmitter();

  public selectedTabInfo: boolean;

  public selectedTabName: string;

  public isClearSelection : boolean = false;

  public tabs: tabValues[];
  public isOn = false;
  public selectedData: SearchResultModal;

  public constructor(public activeModal: NgbActiveModal,
    private globalSearchFiltersService: GlobalSearchFiltersService,
    private translate: TranslateService
  ) {

  }  
  
  public ngOnInit(): void {
    this.tabs = this.searchData.SearchTabs;
    this.selectedTabInfo = this.tabs[0].enableCustomerDivisionSelection;
    this.selectedTabName = this.tabs[0].name;
    this.tabs.forEach(item => {
      if (item.enableCustomerDivisionSelection || item.enableSelectionButtons) {
        item.enableSelectionButtons = false;
      }
    });
  }

  /**
   * Handles the emitted search result, updates the selected data, activates the relevant tab,
   * and closes the modal with the selected result.
   * @param event - The selected search result emitted from the child component.
   */
  public emitSearchedResult(event: SelectedSearchResult): void {
    this.selectedData = Array.isArray(event.selectedSearchedResult) 
      ? event.selectedSearchedResult[0] 
      : event.selectedSearchedResult;
    this.isClearSelection = event.isClearSelection ? true : false;
    this.emitData(event);
    if (event.selectedSearchedResult) {
      // For activateTabs, use the first item if it's an array
      const resultForActivation = Array.isArray(event.selectedSearchedResult) 
        ? event.selectedSearchedResult[0] 
        : event.selectedSearchedResult;
      this.activateTabs(resultForActivation);
      this.activeModal.close(event.selectedSearchedResult);
    }
  }


  emitMultipleSelection(event: SearchResultModal[]): void {
     const resultForActivation = Array.isArray(event) 
        ? event[0] 
        : event;
      this.activateTabs(resultForActivation);
    this.multipleSelectedSearchedResult.emit(event);
    this.activeModal.close(event);
  }

  public emitData(event: SelectedSearchResult): void {
    if (this.isClearSelection) {
      this.isClearSelectionEmitted.emit(this.isClearSelection);
    } else {
      this.selectedSearchedResult.emit(event.selectedSearchedResult);
    }
  }

  public saveSelectedResultInHierarchy($event: SearchResultModal): void {
    this.selectedData = $event;
  }

  /**
   * @description Handles the toggle change event to enable or disable the hierarchy for the selected tab.
   * @param {Event} event - The toggle change event triggered by the user interaction.
   */
  public onToggleChange(event: Event): void {
    const toggleElement = event.target as HTMLInputElement; // Cast the event target to an HTMLInputElement
    this.isOn = toggleElement.checked; // Update the toggle state
    this.globalSearchFiltersService.setEnableToggleDivision(this.isOn);
    this.tabs.forEach((tab) => {
      if (tab.name === this.selectedTabName) {
        tab.hierarchyValues = [];
        tab.enableSelectionButtons = this.isOn;
      }
    });
  }


  public selectedTab($event: { info: string | boolean; label: string }): void {
    if (typeof $event.info === 'string') {
      this.selectedTabInfo = JSON.parse($event.info.toLowerCase());
    } else {
      this.selectedTabInfo = Boolean($event.info);
    }
    this.selectedTabName = $event.label;
  }

  /**
   * Activates the tab corresponding to the selected search result and deactivates other tabs.
   * Sets the selected result as activeData for the matching tab.
   */  
  public activateTabs($event: SearchResultModal): void {
    this.tabs.forEach((tab) => {
      if (tab.name === $event.filterType) {
        tab.activeData = {
          contextPointId: $event.contextPointId,
          contextPointName: $event.contextPointName,
          selectionHierarchy: $event.selectionHierarchy ?? [],
          secondaryText: $event.secondaryText
        };
        tab.isActive = true;
      } else {
        delete tab.activeData;
        delete tab.isActive
      }
    });
  }

  /**
   * TrackBy function for the ngFor directive to improve performance
   * @param index - The index of the item
   * @param item - The tab item
   * @returns A unique identifier for the item
   */
  public trackByTabName(index: number, item: tabValues): string {
    return item.name || index.toString();
  }

}
